import { render, staticRenderFns } from "./PatientControlReservation.vue?vue&type=template&id=51f9e63c&scoped=true&"
import script from "./PatientControlReservation.vue?vue&type=script&lang=ts&"
export * from "./PatientControlReservation.vue?vue&type=script&lang=ts&"
import style0 from "./PatientControlReservation.vue?vue&type=style&index=0&id=51f9e63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f9e63c",
  null
  
)

export default component.exports